import {
  SETTING_CHECKOUT_PAGE_REQUEST,
  SETTING_CHECKOUT_UPDATE_SETTING,
  SETTING_CHECKOUT_SET_SETTING,
  FETCH_OUTLETS,
} from './constant';

export function pageRequest() {
  return { type: SETTING_CHECKOUT_PAGE_REQUEST, payload: {} };
}

export function updateSettingRequest(data) {
  return { type: SETTING_CHECKOUT_UPDATE_SETTING, payload: { data } };
}

export function setSetting(data) {
  return { type: SETTING_CHECKOUT_SET_SETTING, payload: { data } };
}

export function fetchOutlets(outlets) {
  return { type: FETCH_OUTLETS, payload: { outlets } };
}
